import React from "react";
import "./styles.scss";

import { TypeFormation } from "../../models/Formation";

interface IndicateursPerformanceModalProps {
  type?: TypeFormation;
  formationId?: string;
}

const IndicateursPerformanceModal: React.FC<
  IndicateursPerformanceModalProps
> = ({ type, formationId }) => {
  return (
    <div className="indicateurs-performance-modal">
      <h2>Indicateurs de performance</h2>
      {formationId === "formation-cohesion-equipe" ? (
        <div>
          <h3>Indicateurs de performance pour la formation cohésion d’équipe</h3>
          <p><i>Résultats calculés sur les sessions réalisées – période : 2025 - 2026</i></p>
          <ul>
            <li>Nombre de stagiaires formés : 12</li>
            <li>Taux de satisfaction globale : 100%</li>
            <li>Taux d’atteinte des objectifs pédagogiques : 98%</li>
            <li>Taux d’assiduité : 100%</li>
            <li>Taux d’abandon : 0%</li>
            <li>Taux de recommandation : RAS</li>
            <li>Taux de retour des questionnaires : 100%</li>
          </ul>
        </div>
      ) : formationId === "formation-manager-petite-structure-tech" ? (
        <div>
          <h3>Indicateurs de performance pour la formation sur mesure « Manager une petite structure Tech ».</h3>
          <p><i>Résultats calculés sur les sessions réalisées – période : 2025 - 2026</i></p>
          <ul>
            <li>Nombre de stagiaires formés : 2</li>
            <li>Taux de satisfaction globale : 100%</li>
            <li>Taux d’atteinte des objectifs pédagogiques : 100%</li>
            <li>Taux d’assiduité : 100%</li>
            <li>Taux d’abandon : 0%</li>
            <li>Taux de recommandation : RAS</li>
            <li>Taux de retour des questionnaires : 100%</li>
          </ul>
        </div>
      ) : formationId === "bilan-de-competence" ? (
        <div>
          <p><i>Période de référence : 2025-2026</i></p>
          <ul>
            <li>Nombre de bénéficiaires ayant commencé un bilan : 1</li>
            <li>Nombre de bénéficiaires ayant terminé le bilan : 1 (s’il est réellement terminé)</li>
            <li>Taux d’achèvement : 100 % (s’il est terminé)</li>
            <li>Taux de satisfaction : à calculer d’après son questionnaire</li>
            <li>Entretien de suivi à six mois :  non encore échu</li>
            <li>Enquêtes métier réalisées pour valider le projet : 2</li>
          </ul>
        </div>
      ) : (
        <p>
          Cette formation n’ayant pas encore fait l’objet d’une session sur la
          période de référence, les indicateurs de résultats ne sont pas encore
          disponibles. Ils seront publiés à l’issue des premières sessions.
        </p>
      )}
    </div>
  );
};

export default IndicateursPerformanceModal;
